import Vue from 'vue';
import Vuex from 'vuex';
import {bus} from "./bus";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        token: null,
        showProfileForm: false,
        showPasswordForm: false,
        countries: []
    },
    mutations: {
        user(state, user) {
            state.user = user;
        },
        token(state, token) {
            state.token = token;
            Vue.prototype.$service.defaults.headers.common['token'] = token;
            Vue.prototype.$bgService.defaults.headers.common['token'] = token;
        },
        showProfileForm(state, status) {
            state.showProfileForm = status;
        },
        showPasswordForm(state, status) {
            state.showPasswordForm = status;
        },
        countries(state, countries) {
            state.countries = countries;
        }
    },
    actions: {
        login({commit}, data) {
            localStorage.setItem('token', data.token);
            commit('user', data.user);
            commit('token', data.token);
            bus.$emit('initSocket');
            return Promise.resolve();
        },
        logout({commit}) {
            Vue.prototype.$bgService.post('/auth/logout', {token: this.state.token}).then(() => {
            });
            sessionStorage.removeItem('token');
            localStorage.removeItem('token');
            commit('user', null);
            commit('token', null);
            bus.$emit('closeSocket');
            return Promise.resolve();
        }
    }
})
